import { createAction } from '@reduxjs/toolkit';

export default createAction('applyBufferedDeliveryEstimate');
